import {
    BankAccount,
    BankAccountPaymentMethod,
    Card,
    CardPaymentMethod,
    PaymentMethod,
} from '../../features/payments/domain/payments.interface';

export interface CardPaymentMethodClass {
    id: string;
    type: 'card';
    card: Card;
    isDefault(): boolean;
    isDeleted(): boolean;
    setDefault(value: boolean): void;
    setDeleted(): void;
}

export interface BankAccountPaymentMethodClass {
    id: string;
    type: 'us_bank_account';
    bankAccount: BankAccount;
    isDefault(): boolean;
    isDeleted(): boolean;
    setDefault(value: boolean): void;
    setDeleted(): void;
}

export type PaymentMethodClass = CardPaymentMethodClass | BankAccountPaymentMethodClass;

function createCardPaymentMethod(pm: CardPaymentMethod): CardPaymentMethodClass {
    return {
        id: pm.id,
        type: 'card',
        card: { ...pm.card },
        isDefault() {
            return this.card.default;
        },
        isDeleted() {
            return this.card.deleted;
        },
        setDefault(value: boolean) {
            this.card.default = value;
        },
        setDeleted() {
            this.card.deleted = true;
        },
    };
}

function createBankAccountPaymentMethod(pm: BankAccountPaymentMethod): BankAccountPaymentMethodClass {
    return {
        id: pm.id,
        type: 'us_bank_account',
        bankAccount: { ...pm.bankAccount },
        isDefault() {
            return this.bankAccount.default;
        },
        isDeleted() {
            return this.bankAccount.deleted;
        },
        setDefault(value: boolean) {
            this.bankAccount.default = value;
        },
        setDeleted() {
            this.bankAccount.deleted = true;
        },
    };
}

export const PaymentMethodFactory = {
    createPaymentMethods(paymentMethods: PaymentMethod[]): PaymentMethodClass[] {
        return (paymentMethods || []).map((paymentMethod) => this.createPaymentMethod(paymentMethod));
    },

    createPaymentMethod(paymentMethod: PaymentMethod): PaymentMethodClass {
        switch (paymentMethod?.type) {
            case 'card':
                return createCardPaymentMethod(paymentMethod as CardPaymentMethod);
            case 'us_bank_account':
                return createBankAccountPaymentMethod(paymentMethod as BankAccountPaymentMethod);
            default:
                throw new Error(`Unsupported payment method type: ${paymentMethod}`);
        }
    },
};
